const module = { name: 'movie/shared/formatFilter', exports: {} }; const exports = module.exports;



import { default as $ } from 'swug-fdRequire-call:jQuery';



import { swig as swig } from 'require-core';



import { Fandango as Fandango } from 'require-core';



const { minimumLimit } = readPageContext(Fandango)


const Selectors = {
    CONTAINER: '#lazyload-format-filters',
    PLACEHOLDER: 'format-filter-placeholder',
    SELECTED_FORMAT: '#mop-selected-format',
}


const Styles = {
    HIDE: 'hide'
}


const Markup = {
    PLACEHOLDER: '<div class="icon format-filter-placeholder format-filter-placeholder--mobile">Loading format filterse&hellip;</div>'
}


const FormatFilters = {
    ALL: 'all',
    DOLBY: 'dolby',
    IMAX: 'imax',
}
function readPageContext(Fandango) {
    const { context: { formatFilter: { minimumLimit } = {} }, } = Fandango;
    return {
        minimumLimit: minimumLimit || 1,
    };
}
function moveToFront(arySource, value) {
    const index = arySource.indexOf(value);
    const name = index >= 0 ? arySource.splice(index, 1)[0] : '';
    name && arySource.unshift(name);
}
function addToFront(arySource, value) {
    arySource.unshift(value);
}
function isMemberOf(arySource, value) {
    return Array.isArray(arySource) && arySource.includes(value);
}
function getMarkup(formatsData, activeFilter, hasShowtimes) {
    activeFilter = activeFilter || FormatFilters.ALL;
    if (Array.isArray(formatsData.all) && formatsData.all.length > 1) {
        formatsData.all.push(FormatFilters.ALL);
    }
    if (!isMemberOf(formatsData.all, activeFilter) && formatsData.all.length > 0) {
        activeFilter = FormatFilters.ALL;
    }
    const formats = formatsData.availableFormats;
    if (!Array.isArray(formats) || !formats.length || (formats.length < minimumLimit && hasShowtimes)) {
        return '';
    }
    if (!hasShowtimes) {
        formats.push(activeFilter);
    }
    moveToFront(formats, FormatFilters.IMAX);
    if (formats.length > 0) {
        addToFront(formats, FormatFilters.ALL);
    }
    return swig.render('_formatFilter', {
        formats,
        activeFilter,
        hasShowtimes,
    });
}
function hide() {
    $(Selectors.CONTAINER).addClass(Styles.HIDE);
}
function showPlaceholder() {
    const $container = $(Selectors.CONTAINER);
    const placeholder = document.getElementById(Selectors.PLACEHOLDER);
    if (!placeholder) {
        $container.html(Markup.PLACEHOLDER);
    }
    $container.removeClass(Styles.HIDE);
}
function showFilters(formatsData, activeFilter = FormatFilters.ALL, hasShowtimes = true) {
    const markup = getMarkup(formatsData, activeFilter, hasShowtimes);
    if (markup) {
        $(Selectors.CONTAINER).html(markup);
    }
    else {
        hide();
    }
    return Boolean(markup);
}
module.exports = {
    FormatFilters,
    getMarkup,
    hide,
    showPlaceholder,
    showFilters,
};
export default module.exports;